import { useSnapshot } from "valtio/react";
import { useCallback, useMemo } from "react";
import { useParams } from "next/navigation";
import { pubsub } from "utils";
import { PortfolioType } from "../components/Portfolio/types";
import { pubSubKeyMap } from "../utils/pubSubKeyMap";
import { AppStore } from "../store/modules/app";
import { usePortfolioRouting } from "./usePortfolioRouting";
import { usePortfolioType } from "./usePortfolioType";
import { useShellRouter } from "./useShellAwareRouter";
import { usePortfolioPage } from "./usePortfolioPage";

export const usePortfolioHelp = () => {
  const router = useShellRouter();
  const { buildHoldingsPath } = usePortfolioRouting();
  const { currentType } = usePortfolioType();
  const { portfolioId } = useParams<{ portfolioId: string }>();
  const { portfolioChartVisabled } = useSnapshot(AppStore);
  const { data } = usePortfolioPage();

  const hasHoldings = (data?.length ?? 0) > 0;

  const shouldShowChart = useMemo(
    () => currentType === PortfolioType.EXTERNAL && hasHoldings,
    [currentType, hasHoldings],
  );

  const showWatchlistAddAssets = false;
  const shouldShowAddAssets = false;

  const showChart = () => {
    pubsub.emit(pubSubKeyMap.PORTFOLIO_CHART_SHOW, { viewName: "summary" });
    AppStore.portfolioChartVisabled = !portfolioChartVisabled;
  };

  const switchAccount = useCallback(
    (accountId: string) => {
      if (accountId === portfolioId) {
        return;
      }
      router.replace(buildHoldingsPath(accountId));
    },
    [buildHoldingsPath, portfolioId, router],
  );

  return {
    hasWatchlistAssets: false,
    hasExternalAssets: hasHoldings,
    shouldShowChart,
    showWatchlistAddAssets,
    shouldShowAddAssets,
    currentType,
    showChart,
    externalFolders: [],
    currentAccountId: portfolioId,
    switchAccount,
  };
};
